import { DSR_ACCESS_TOKEN } from "@/store/constants/global";
import DiaryListConstants from "@/store/constants/diaryListRecords";

// initial state
const state = () => ({
  isLoggedIn: false,
  confirmAttr: { attr: "", orderId: -1 },
});

// getters
const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn;
  },
  getConfirmAttr: (state) => {
    return state.confirmAttr;
  },
};

// actions
const actions = {
  async initApp({ commit }) {
    const accessToken = localStorage.getItem(DSR_ACCESS_TOKEN);
    if (accessToken) {
      commit("setIsLoggedIn", true);
      this.dispatch(DiaryListConstants.DISPATCH.getSiteRecords);
      this.dispatch(DiaryListConstants.DISPATCH.getMeRecord);
    } else {
      console.log("please login");
      // logout();
    }
  },
};

// mutations
const mutations = {
  setIsLoggedIn(state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn;
  },
  setConfirmAttr(state, { attr, orderId }) {
    state.confirmAttr.attr = attr;
    state.confirmAttr.orderId = orderId;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
